import clsx from 'clsx';
import Typography from '@mui/material/Typography';
import {useTranslation} from 'react-i18next';


export default function Zero({ value }) {
  const {t} = useTranslation('navigation');

  return (
    <div
      className={clsx('flex flex-1 flex-col items-center justify-center p-24', false && 'hidden')}
    >
      <Typography className='text-13 sm:text-20 mb-16' color='textSecondary'>
        {t('THERE_ARE_NO')}{' '}
        {value === 'Completed'
          ? t('TICKETS_COMPLETED_TODAY')
          : value === 'Delayed'
          ? t('DELAYED_TICKETS')
          : t('TICKETS_IN_PROGRESS')}
      </Typography>
    </div>
  );
}
